import { Icon } from '@iconify/react/dist/iconify.js'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FilterdData } from '../../helper/FilterdData';
import GetSoldItemsData from '../../data/Comman/GetSoldItesmData';
import { Languages } from '../../Utils/Languages';
import GetBusinessDataFirebase from '../../data/Firebase/Business/GetBusinessDataFirebase';
import { PremiumFeatureOnlyModal } from '../PremiumFeatureOnlyModal';

const BusinessOverview = ({ state, dispatch, isdashboard, }) => {

    const [totalEarning, setTotalEarning] = useState(state?.TOTALEARNING);
    const [totalPaidEarning, setTotalPaidEarning] = useState(state?.TOTALPAIDEARNING);
    const [totalUnpaidEarning, setTotalUnpaidEarning] = useState(state?.TOTALUNPAIDEARNING);
    const [businessData, setBusinessData] = useState(state?.BUSINESSES);
    const [invoiceData, setInvoiceData] = useState(state?.INVOICES);
    const [customerData, setCustomerData] = useState(state?.CUSTOMERS);
    const [soldItemsData, setSoldItemsData] = useState(state?.SOLDITEMS);
    const [expenseData, setexpenseData] = useState(0);
    const [saleReturnData, setsaleReturnData] = useState(0);
    const [isDisplayPrimiumFeatureModel, setIsDisplayPrimiumFeatureModel] = useState(false);
    const isPremium = state?.PREMIUM;




    useEffect(() => {
        if (!state) return; // Ensure state is defined

        setBusinessData(FilterdData(state, state?.BUSINESSES, "creationDate"));


        setInvoiceData(FilterdData(state, state?.INVOICES, "date"));
        const uniqueCustomers = FilterdData(state, state?.CUSTOMERS, "date");
        setCustomerData(uniqueCustomers);

        const soldItems = [];

        FilterdData(state, state?.INVOICES, "date")?.forEach((info) => {
            info?.items?.forEach((item) => {
                const price = (parseFloat(item.price) || 0).toFixed(2);
                const amount = (parseFloat(item.amount) || 0).toFixed(2);

                const existingItem = soldItems.find(soldItem =>
                    soldItem.name === item.name &&
                    soldItem.companyId === info.companyId &&
                    soldItem.price === price
                );

                if (existingItem) {
                    existingItem.quantity += parseInt(item.quantity);
                    existingItem.amount = (parseFloat(existingItem.amount) + parseFloat(amount)).toFixed(2);
                } else {
                    soldItems.push({
                        srNo: soldItems.length + 1,
                        companyId: info.companyId,
                        invoiceId: info.invoiceId,
                        name: item.name,
                        price: price,
                        quantity: parseInt(item.quantity),
                        amount: amount
                    });
                }
            });
        });

        setSoldItemsData(soldItems);

        let totalEarnings = 0;
        let paidEarnings = 0;
        let unpaidEarnings = 0;

        FilterdData(state, state?.INVOICES, "date")?.forEach((info) => {
            const amount = parseFloat(info?.totalAmount) || 0;

            if (info.totalAmount) {
                totalEarnings += amount;
            }

            if (info.paidFlagKey === "true" || info.paidFlagKey === true) {
                paidEarnings += amount;
            } else {
                unpaidEarnings += amount;
            }
        });

        setTotalEarning(totalEarnings.toFixed(2));
        setTotalPaidEarning(paidEarnings.toFixed(2));
        setTotalUnpaidEarning(unpaidEarnings.toFixed(2));


        let totalExpence = 0;
        let totalSaleReturn = 0;

        FilterdData(state, state?.EXPENSE, "createdDate")?.forEach((info) => {
            totalExpence += parseFloat(info.amount);
        })
        FilterdData(state, state?.SALERETURN, "creationDate")?.forEach((info) => {
            totalSaleReturn += parseFloat(info.totalAmount);
        })


        setsaleReturnData(totalSaleReturn?.toFixed(2))

        setexpenseData(totalExpence?.toFixed(2))

    }, [state?.ACTIVEFILTER, state?.BUSINESSES, state?.INVOICES, state?.EXPENSE]);

    const [businessLoaded, setBusinessLoaded] = useState(false);
    // useEffect(() => {
    //     const fetchBusinesses = async () => {
    //         await GetBusinessDataFirebase(state, disptch);
    //         setBusinessLoaded(true);
    //     };
    //     fetchBusinesses();
    // }, []);

    return (
        <div className="col-12 pt-1">
            {businessLoaded && state?.BUSINESSES?.length === 0 && (
                <h6 className="mb-16">  {Languages[state?.LANGUAGE]?.business_overview_Insights}</h6>
            )}
            <div className="row gy-4">
                <div className="col-lg-4 col-sm-6">
                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: "GUESTMODELPOPUP", payload: true });
                            }
                        }}
                        to={state?.USERID ? "/expense" : "#"}
                        className="card px-24 py-24 shadow-none radius-12 border h-100 bg-gradient-start-1 d-flex align-items-center"
                    >
                        <div className="card-body p-0 w-100 d-flex align-items-center">
                            <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                <span className="w-40-px h-40-px bg-info text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                    <Icon icon="mdi:bank-minus" className="icon" />
                                </span>
                                <div className="flex-grow-1 min-w-0">
                                    <h6 className="fw-semibold mb-0 text-truncate"
                                        style={{
                                            fontSize: "clamp(14px, 2.5vw, 18px)",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            wordBreak: "break-word"
                                        }}>{state?.SYMBOL === "$" ? `${state?.CURRENCYCODE} ${state?.SYMBOL} ` : `${state?.SYMBOL} `} {expenseData || "0.00"}</h6>
                                    <span className="fw-medium text-secondary-light text-md">{Languages[state?.LANGUAGE]?.total_expense}</span>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>
                {/* Total Earning */}
                <div className="col-lg-4 col-sm-6">
                    <div className="card px-3 py-3 shadow-none radius-12 border h-100 bg-gradient-start-4 d-flex align-items-center">
                        <div className="card-body p-0 w-100 d-flex align-items-center">
                            <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                <span className="w-40-px h-40-px bg-success-600 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                    <Icon icon="mdi:wallet" className="icon" />
                                </span>
                                <div className="flex-grow-1 min-w-0">
                                    <h6 className="fw-semibold mb-0 text-truncate"
                                        style={{
                                            fontSize: "clamp(14px, 2.5vw, 18px)",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            wordBreak: "break-word"
                                        }}>
                                        {state?.SYMBOL === "$" ? `${state?.CURRENCYCODE} ${state?.SYMBOL} ` : `${state?.SYMBOL} `} {totalEarning || state?.TOTALEARNING}
                                    </h6>
                                    <span className="fw-medium text-secondary-light text-md">{Languages[state?.LANGUAGE]?.total_earning}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Total Paid Earning */}
                <div className="col-lg-4 col-sm-6">
                    <div className="card px-24 py-24 shadow-none radius-12 border h-100 bg-gradient-start-3 d-flex align-items-center">
                        <div className="card-body p-0 w-100 d-flex align-items-center">
                            <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                <span className="w-40-px h-40-px bg-primary-600 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                    <Icon icon="mdi:cash-check" className="icon" />
                                </span>
                                <div className="flex-grow-1 min-w-0">
                                    <h6 className="fw-semibold mb-0 text-truncate"
                                        style={{
                                            fontSize: "clamp(14px, 2.5vw, 18px)",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            wordBreak: "break-word"
                                        }}>{state?.SYMBOL === "$" ? `${state?.CURRENCYCODE} ${state?.SYMBOL} ` : `${state?.SYMBOL} `} {totalPaidEarning}</h6>
                                    <span className="fw-medium text-secondary-light text-md">{Languages[state?.LANGUAGE]?.total_paid_earning}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Total Unpaid Earning */}
                <div className="col-lg-4 col-sm-6">
                    <div className="card px-24 py-24 shadow-none radius-12 border h-100 bg-gradient-start-5 d-flex align-items-center">
                        <div className="card-body p-0 w-100 d-flex align-items-center">
                            <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                <span className="w-40-px h-40-px bg-danger-600 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                    <Icon icon="mdi:alert-circle-outline" className="icon" />
                                </span>
                                <div className="flex-grow-1 min-w-0">
                                    <h6 className="fw-semibold mb-0 text-truncate"
                                        style={{
                                            fontSize: "clamp(14px, 2.5vw, 18px)",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            wordBreak: "break-word"
                                        }}>{state?.SYMBOL === "$" ? `${state?.CURRENCYCODE} ${state?.SYMBOL} ` : `${state?.SYMBOL} `} {totalUnpaidEarning}</h6>
                                    <span className="fw-medium text-secondary-light text-md">{Languages[state?.LANGUAGE]?.total_unpaid_earning}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Total Businesses */}
                {isdashboard === "true" && (
                    <div className="col-lg-4 col-sm-6">
                        <Link
                            onClick={(e) => {
                                if (!state?.USERID) {
                                    e.preventDefault();
                                    dispatch({ type: "GUESTMODELPOPUP", payload: true });
                                }
                            }}
                            to={state?.USERID ? "/business-list" : "#"}
                            className="card px-24 py-24 shadow-none radius-12 border h-100 bg-gradient-start-3 d-flex align-items-center"
                        >
                            <div className="card-body p-0 w-100 d-flex align-items-center">
                                <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                    <span className="w-40-px h-40-px bg-info-600 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon icon="tabler:building-store" className="icon" />
                                    </span>
                                    <div className="flex-grow-1 min-w-0">
                                        <h6
                                            className="fw-semibold mb-0 text-truncate"
                                            style={{
                                                fontSize: "clamp(14px, 2.5vw, 18px)",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {businessData?.length}
                                        </h6>
                                        <span className="fw-medium text-secondary-light text-md">
                                            {Languages[state?.LANGUAGE]?.total_business}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                )}


                {/* Total Invoices */}
                <div className="col-lg-4 col-sm-6">
                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: "GUESTMODELPOPUP", payload: true });
                            }
                        }}
                        to={state?.USERID ? "/invoice-list" : "#"}
                        className="card px-24 py-24 shadow-none radius-12 border h-100 bg-gradient-start-5 d-flex align-items-center"
                    >
                        <div className="card-body p-0 w-100 d-flex align-items-center">
                            <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                <span className="w-40-px h-40-px bg-warning-600 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                    <Icon icon="hugeicons:invoice-03" className="icon" />
                                </span>
                                <div className="flex-grow-1 min-w-0">
                                    <h6 className="fw-semibold mb-0 text-truncate"
                                        style={{
                                            fontSize: "clamp(14px, 2.5vw, 18px)",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            wordBreak: "break-word"
                                        }}>{invoiceData?.length}</h6>
                                    <span className="fw-medium text-secondary-light text-md">{Languages[state?.LANGUAGE]?.total_invoices}</span>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>

                {/* Total Customers */}
                <div className="col-lg-4 col-sm-6">
                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: "GUESTMODELPOPUP", payload: true });
                            }
                        }}
                        to={state?.USERID ? "/customer-list" : "#"}
                        className="card px-24 py-24 shadow-none radius-12 border h-100 bg-gradient-start-2 d-flex align-items-center"
                    >
                        <div className="card-body p-0 w-100 d-flex align-items-center">
                            <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                <span className="w-40-px h-40-px bg-purple text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                    <Icon icon="heroicons-outline:users" className="icon" />
                                </span>
                                <div className="flex-grow-1 min-w-0">
                                    <h6 className="fw-semibold mb-0 text-truncate"
                                        style={{
                                            fontSize: "clamp(14px, 2.5vw, 18px)",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            wordBreak: "break-word"
                                        }}>{customerData?.length}</h6>
                                    <span className="fw-medium text-secondary-light text-md">{Languages[state?.LANGUAGE]?.total_customers}</span>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>

                {/* Total Sold Items */}
                <div className="col-lg-4 col-sm-6">
                    <Link
                        onClick={(e) => {
                            if (!state?.USERID) {
                                e.preventDefault();
                                dispatch({ type: "GUESTMODELPOPUP", payload: true });
                            }
                        }}
                        to={state?.USERID ? "/sold-items-list" : "#"}
                        className="card px-24 py-24 shadow-none radius-12 border h-100 bg-gradient-start-1 d-flex align-items-center"
                    >
                        <div className="card-body p-0 w-100 d-flex align-items-center">
                            <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                <span className="w-40-px h-40-px bg-info text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                    <Icon icon="mdi:cart-check" className="icon" />
                                </span>
                                <div className="flex-grow-1 min-w-0">
                                    <h6 className="fw-semibold mb-0 text-truncate"
                                        style={{
                                            fontSize: "clamp(14px, 2.5vw, 18px)",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            wordBreak: "break-word"
                                        }}>{soldItemsData?.length}</h6>
                                    <span className="fw-medium text-secondary-light text-md">{Languages[state?.LANGUAGE]?.total_sold_items}</span>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>

                <div className="col-lg-4 col-sm-6">
                    <Link onClick={(e) => {
                        if (!state?.USERID) {
                            e.preventDefault();
                            dispatch({ type: "GUESTMODELPOPUP", payload: true });
                            return;
                        }
                        if (!isPremium) {
                            setIsDisplayPrimiumFeatureModel(true);
                        }
                    }}
                        to={state?.USERID && isPremium ? "/sales-return" : "#"}
                        className="card px-24 py-24 shadow-none radius-12 border h-100 bg-gradient-start-4 d-flex align-items-center">
                        <div className="card-body p-0 w-100 d-flex align-items-center">
                            <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                <span className="w-40-px h-40-px bg-success text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                    <Icon icon="lsicon:sales-return-outline" className="menu-icon" />
                                </span>
                                <div className="flex-grow-1 min-w-0">
                                    <h6 className="fw-semibold mb-0 text-truncate"
                                        style={{
                                            fontSize: "clamp(14px, 2.5vw, 18px)",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            wordBreak: "break-word"
                                        }}>{state?.SYMBOL === "$" ? `${state?.CURRENCYCODE} ${state?.SYMBOL} ` : `${state?.SYMBOL} `} {saleReturnData || "0.00"}</h6>
                                    <span className="fw-medium text-secondary-light text-md">{Languages[state?.LANGUAGE]?.total_salereturn}</span>
                                </div>
                            </div>
                        </div>
                    </Link>
                </div>

                {isdashboard === "false" && (
                    <div className="col-lg-4 col-sm-6">
                        <Link
                            to="/business-list"
                            className="card px-24 py-24 shadow-none radius-12 border h-100 bg-gradient-start-3 d-flex align-items-center"
                        >
                            <div className="card-body p-0 w-100 d-flex align-items-center">
                                <div className="d-flex align-items-center gap-3 w-100 flex-wrap">
                                    <span className="w-40-px h-40-px bg-info-600 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                        <Icon icon="tabler:building-store" className="icon" />
                                    </span>
                                    <div className="flex-grow-1 min-w-0">
                                        <h6
                                            className="fw-semibold mb-0 text-truncate"
                                            style={{
                                                fontSize: "clamp(14px, 2.5vw, 18px)",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {businessData?.length}
                                        </h6>
                                        <span className="fw-medium text-secondary-light text-md">
                                            {"Net Profit"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                )}
                {/* <div className="dashboard-main-body"> */}

                <PremiumFeatureOnlyModal
                    isOpen={isDisplayPrimiumFeatureModel}
                    onClose={() => setIsDisplayPrimiumFeatureModel(false)}
                    featureName="Sales-Return"
                />
                {/* </div> */}
            </div>

        </div>
    )
}

export default BusinessOverview